import { Content } from '@raydiant/api-client-js';
import cn from 'classnames';
import DataTable from '../../components/DataTable/DataTable';
import DataTableHeader from '../../components/DataTable/DataTableHeader';
import Text from '@raydiant/raydial/components/Text';
import DataTableCell from '../../components/DataTable/DataTableCell';
import { getPresentationData } from '../LibraryPage/utils';
import ApplicationIcon from '../LibraryPage/v2/components/ApplicationIcon';
import moment from 'moment';
import Checkbox from 'raydiant-elements/core/Checkbox';
import { NodeType } from '../../utilities';

export interface AddContentPageListViewProps {
  contents: Content[];
  selectedItems: { id: string; type: NodeType }[];
  onClick: (content: Content) => void;
}

const AddContentPageListView = ({
  contents,
  selectedItems,
  onClick,
}: AddContentPageListViewProps) => {
  return (
    <div className="w-full">
      <DataTable<Content>
        className=""
        currentPage={0}
        data={contents}
        showPagination={false}
        headers={
          <tr>
            <DataTableHeader<Content>
              className="!text-left sticky left-0 !bg-gray-100 !text-gray-500 !fill-gray-500"
              wrapperClassName="!justify-start"
              onSort={() => {}}
            >
              <Text className="text-base font-semibold pl-8">name</Text>
            </DataTableHeader>
            <DataTableHeader<Content>
              className="!bg-gray-100 !text-gray-500 !fill-gray-500"
              wrapperClassName="!justify-start"
              onSort={() => {}}
              showSort={false}
              sortDirection={undefined}
            >
              <Text className="text-base font-semibold">owner</Text>
            </DataTableHeader>
            <DataTableHeader<Content>
              className="!bg-gray-100 !text-gray-500 !fill-gray-500"
              wrapperClassName="!justify-start"
              onSort={() => {}}
              showSort={false}
              sortDirection={undefined}
            >
              <Text className="text-base font-semibold">last modified</Text>
            </DataTableHeader>
            <DataTableHeader<Content>
              className="!bg-gray-100 !text-gray-500 !fill-gray-500"
              wrapperClassName="!justify-start"
              onSort={() => {}}
              showSort={false}
              sortDirection={undefined}
            ></DataTableHeader>
          </tr>
        }
        onPageChange={() => {}}
        pageCount={1}
        renderRow={(content) => (
          <tr
            key={content.resourceId}
            onClick={() => onClick(content)}
            className={cn('cursor-pointer')}
          >
            <DataTableCell
              hasSort
              className="!rounded-2xl p-2.5"
              wrapperClassName="text-left flex"
            >
              <div className="w-4 mr-4">
                {content.resourceType !== 'folder' && (
                  <Checkbox
                    checked={selectedItems.some(
                      (item) =>
                        item.id === content.id &&
                        item.type === content.resourceType,
                    )}
                  />
                )}
              </div>{' '}
              <ApplicationIcon
                className="mr-4"
                url={getPresentationData(content).applicationIconUrl}
              />
              <Text className="text-lg w-[191px] truncate">{content.name}</Text>
            </DataTableCell>
            <DataTableCell
              className="p-2.5"
              wrapperClassName="min-w-[264px] text-left"
            >
              <Text className="w-[138px] text-lg truncate">
                {content.ownedBy?.name}
              </Text>
            </DataTableCell>
            <DataTableCell
              className="p-2.5"
              wrapperClassName="min-w-[240px] text-left"
            >
              <Text className="w-[217px] text-lg truncate">
                {moment(content.updatedAt).format('ll')}
              </Text>
            </DataTableCell>
          </tr>
        )}
      />
    </div>
  );
};

export default AddContentPageListView;
